import { Instagram, Linkedin, Twitter, Mail } from "lucide-react";
import { ZypLogo } from "@/components/ZypLogo";

const cols = [
  {
    title: "Product",
    links: [
      ["How it works", "#how"],
      ["Plans", "#plans"],
      ["Partners", "#partners"],
      ["FAQs", "#faqs"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "#"],
      ["Careers", "#"],
      ["Press", "#"],
      ["Contact", "#waitlist"],
    ],
  },
  {
    title: "Partners",
    links: [
      ["Become a Zypper", "#partners"],
      ["Apartment Societies", "#partners"],
      ["Insurance partners", "#"],
      ["Brand partners", "#"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy", "#"],
      ["Terms", "#"],
      ["DPDP 2023", "#"],
      ["Refund policy", "#"],
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-zyp-navy/10 px-6 md:px-12 pt-20 pb-10 bg-zyp-cream"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-12 mb-16">
          <div className="col-span-2">
            <div className="mb-4">
              <ZypLogo variant="footer" />
            </div>
            <p className="text-zyp-navy/70 text-sm max-w-xs leading-relaxed">
              The smarter way to shine. Subscription-led, doorstep car &amp; bike care for apartment dwellers in Bangalore.
            </p>
            <div className="mt-6">
              <a
                href="tel:+917022237797"
                data-testid="footer-phone"
                className="inline-flex items-center gap-2 text-sm text-zyp-navy hover:text-zyp-highlight transition-colors"
              >
                <span className="text-zyp-navy/60">Call us:</span>
                <span className="font-semibold text-zyp-highlight">+91 70222 37797</span>
              </a>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[
                { Icon: Instagram, label: "instagram", href: "#" },
                { Icon: Twitter, label: "twitter", href: "#" },
                { Icon: Linkedin, label: "linkedin", href: "#" },
                { Icon: Mail, label: "email", href: "mailto:care@zyp.services" },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  data-testid={`footer-social-${label}`}
                  className="h-9 w-9 rounded-full border border-zyp-navy/15 flex items-center justify-center text-zyp-navy/60 hover:text-zyp-highlight hover:border-zyp-highlight/30 transition-all"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <div className="text-xs uppercase tracking-[0.22em] text-zyp-navy/50 mb-4">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-zyp-navy/75 hover:text-zyp-navy transition-colors"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="relative">
          <div
            aria-hidden
            className="font-heading font-semibold tracking-tighter text-[20vw] leading-[0.9] text-transparent bg-clip-text bg-gradient-to-b from-zyp-navy/10 to-transparent select-none"
          >
            Zyp.
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-10 pt-6 border-t border-zyp-navy/10">
          <p className="text-xs text-zyp-navy/50">
            © {new Date().getFullYear()} GLEAM SMARTMOBILITY TECHNOLOGIES PRIVATE LIMITED Built in Bangalore.
          </p>
          <p className="text-xs text-zyp-navy/50">
            Made with obsession for clean cars.
          </p>
        </div>
      </div>
    </footer>
  );
}
